<template>
  <b-modal class="modal-lg" size="lg" id="notifyModal" ref="notify-modal" :title="notifyModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo(notifyModal.modalData.entries)" @hide="resetModal('main'); clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'bell']" size="1x" class="mr-2"/> {{ notifyModal.modalData.title }}</h5>
      <button ref="button-close-remittance" aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="notifyModal.docuData.docsChecked && notifyModal.docuData.docsChecked.length">
        <template v-if="notifyModal.modalData.entries == 'single'">
          <h5>{{ t('notifyRemittanceModalDocumentDetails', 'notifyRemittanceModalDocumentDetails') }}</h5>
            <template v-if="notifyModal.docuData.documentDetails">
              <b-table id="document-details-table" striped hover bordered responsive foot-clone :thead-class="'brand-color'" class="mt-3" :items="notifyModal.docuData.documentDetails" :fields="fields" :total-rows="notifyModal.docuData.documentDetails.length">
                <template v-slot:head(customer_ref)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(document)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(status)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(value)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:cell(customer_ref)="data">
                  <template v-if="(Number(userLevel) > 0.50) ? true : false" >
                    <router-link :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                      {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
                    </router-link>
                  </template>
                  <template v-else>
                    <span :id="'cust_reference_' + data.item.id"> {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }} </span>
                  </template>
                </template>
                <template v-slot:cell(document)="data">
                  <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'online' }}" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`" target="_blank">
                    {{ data.item.reference }}
                  </router-link>
                  <template v-if="(Number(userLevel) > 2.50) ? true : false">
                    <template v-if="data.item.email_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'email_cover' }}" :title="`${data.item.reference} Email Coversheet`" target="_blank">
                        [e]
                      </router-link>
                    </template>
                    <template v-if="data.item.fax_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'fax_cover' }}" :title="`${data.item.reference} Fax Coversheet`" target="_blank">
                        [f]
                      </router-link>
                    </template>
                    <template v-if="data.item.post_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'post_cover' }}" :title="`${data.item.reference} Post Coversheet`" target="_blank">
                        [p]
                      </router-link>
                    </template>
                  </template>
                  <template v-if="userLevel == 3.00">
                    <fontAwesomeIcon :icon="['fas', 'info-circle']" size="1x" :id="`info-${data.item.id}`"
                    @click="modalCreator({id: 'subInfoModal', title: t('documentInfoModalHead','documentInfoModalHead'), level: 'sub', open: 'open'}, data.item, $event.target)"
                    class="text-primary showhand align-middle ml-1" visibility="visible"/>
                  </template>
                  <span v-if="data.item.is_read == 1" class="text-white bg-green px-1 ml-1" :title="`Read by ${data.item.read_by}`">R</span>
                  <template v-if="data.item.downloaded == 1">
                    <span class="text-white bg-blue px-1 ml-1" :title="`Downloaded by ${data.item.downloaded_by}`">D</span>
                  </template>
                  <span v-if="data.item.is_hidden == 3" class="text-white bg-yellow px-1 ml-1" title="Can only be unhidden by newsnet staff">N</span>
                  <span v-if="data.item.accepted">{{t('accepted', 'accepted')}}</span>
                </template>
                <template v-slot:cell(status)="data">
                  <b-form-select ref="statusSelector" v-model="formData[data.item.id]" @change="modalCaller" size="sm">
                    <option :value="''" selected></option>
                    <option :value="`queried-${data.index}`">{{t('labelQueried', 'labelQueried')}}</option>
                    <option value="paid">{{t('labelPaid', 'labelPaid')}}</option>
                  </b-form-select>
                </template>
                <template v-slot:cell(value)="data">
                  <template v-if="data.item.total_value">
                    <template v-if="displaySettings.formatValues">
                      {{ data.item.total_value | numberFormat(2) }}
                    </template>
                    <template v-else>
                      {{ data.item.total_value }}
                    </template>
                  </template>
                </template>
                <template v-slot:foot(customer_ref)="data">
                  <span></span>
                </template>
                <template v-slot:foot(document)="data">
                  <span></span>
                </template>
                <template v-slot:foot(status)="data">
                  <span></span>
                </template>
                <template v-slot:foot(value)="data">
                  <template v-if="totalValue">
                    {{t('total', 'total')}} <strong class="text-bold">{{totalValue | numberFormat(2) }}</strong>
                  </template>
                  <template v-else>
                    <span></span>
                  </template>
                </template>
              </b-table>
            </template>
          <h5>{{ t('notifyRemittanceModalPaymentDetails', 'notifyRemittanceModalPaymentDetails') }}</h5>
          <b-form-group>
            <div class="row col-12 align-items-center py-1">
              <label for="paid-via" class="d-block col-8">{{t('willBePaidViaPlsChooseMethod','willBePaidViaPlsChooseMethod') }} *</label>
              <!--<b-form-select id="paid-via" v-model="formData.paymentMethod.paidVia" class="col-4" :options="paymentMethods" ></b-form-select>-->
              <b-form-select id="paid-via" v-model="formData.paymentMethod.paidVia" class="col-4" >
                <b-form-select-option :value="''">{{t('chooseMethod','chooseMethod')}}</b-form-select-option>
                <b-form-select-option value="Bacs">{{t('labelBACS','labelBACS')}}</b-form-select-option>
                <b-form-select-option value="Cheque">{{t('labelCheque','labelCheque')}}</b-form-select-option>
                <b-form-select-option value="Credit_card">{{t('labelCreditCard','labelCreditCard')}}</b-form-select-option>
                <b-form-select-option v-if="clientName == 'look' || clientName == 'looktest'" value="ACH">{{t('labelACH','labelACH')}}</b-form-select-option>
                <b-form-select-option value="Other">{{t('labelOther','labelOther')}}</b-form-select-option>
              </b-form-select>
            </div>
            <div class="row col-12 align-items-center py-1">
              <label for="paid-on" class="d-block col-8">{{t('willBePaidOnPlsChooseDate','willBePaidOnPlsChooseDate') }}</label>
              <datePicker id="paid-on" v-model="formData.paymentMethod.paidOn" class="form-control text-center col-4" :config="datePickerConfig" :placeholder="t('willBePaidOnPlsChooseDate','willBePaidOnPlsChooseDate')"></datePicker>
            </div>
            <template v-if="paidVia == 'Other'">
              <div class="row col-12 align-items-center py-1">
                <label for="paid-other" class="d-block col-8">{{t('pleaseSpecify','pleaseSpecify') }} *</label>
                <input type="text" id="paid-other" v-model="formData.paymentMethod.other" class="form-control text-center col-4" :placeholder="t('pleaseSpecify','pleaseSpecify')">
              </div>
            </template>
            <template v-if="clientName == 'INTE'">
              <div class="row col-12 align-items-top py-1">
                <label for="paid-info" class="d-block col-8">{{t('additionalInstruction','additionalInstruction') }}</label>
                <b-form-textarea id="paid-info" v-model="formData.paymentMethod.info" class="col-4" rows="5" max-rows="5">
                </b-form-textarea>
              </div>
            </template>
          </b-form-group>
          <p class="text-center">{{t('notifyRemittanceModalMandatory', 'notifyRemittanceModalMandatory')}}</p>
        </template>
        <template v-if="notifyModal.modalData.entries == 'multi'">
          <h5>{{ t('notifyRemittanceModalDocumentDetails', 'notifyRemittanceModalDocumentDetails') }}</h5>
            <template v-if="notifyModal.docuData.documentDetails">
              <b-table id="document-details-table" striped hover bordered responsive foot-clone :thead-class="'brand-color'" class="mt-3" :items="notifyModal.docuData.documentDetails" :fields="fields" :total-rows="notifyModal.docuData.documentDetails.length">
                <template v-slot:head(customer_ref)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(document)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(status)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(value)="data">
                  <span> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:cell(customer_ref)="data">
                  <template v-if="(Number(userLevel) > 0.50)" >
                    <router-link :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${data.item.customer_ref}`}" :title="t('tooltipViewCustomerDetails', 'tooltipViewCustomerDetails')">
                      {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }}
                    </router-link>
                  </template>
                  <template v-else>
                    <span :id="'cust_reference_' + data.item.id"> {{ (data.item.customer_ref) ? data.item.customer_ref : t('labelNotYetAssigned', 'labelNotYetAssigned') }} </span>
                  </template>
                </template>
                <template v-slot:cell(document)="data">
                  <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'online' }}" :title="`${data.item.reference} - ${t('batchNumber', 'batchNumber')} ${data.item.batch}`" target="_blank">
                    {{ data.item.reference }}
                  </router-link>
                  <template v-if="(Number(userLevel) > 2.50)">
                    <template v-if="data.item.email_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'email_cover' }}" :title="`${data.item.reference} Email Coversheet`" target="_blank">
                        [e]
                      </router-link>
                    </template>
                    <template v-if="data.item.fax_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'fax_cover' }}" :title="`${data.item.reference} Fax Coversheet`" target="_blank">
                        [f]
                      </router-link>
                    </template>
                    <template v-if="data.item.post_cover == 1">
                      <router-link :to="{ name: 'view_document', params: { id: data.item.id, type: 'post_cover' }}" :title="`${data.item.reference} Post Coversheet`" target="_blank">
                        [p]
                      </router-link>
                    </template>
                  </template>
                  <template v-if="userLevel == 3.00">
                    <fontAwesomeIcon :icon="['fas', 'info-circle']" size="1x" :id="`info-${data.item.id}`"
                    @click="modalCreator({id: 'subInfoModal', title: t('documentInfoModalHead','documentInfoModalHead'), level: 'sub', open: 'open'}, data.item, $event.target)"
                    class="text-primary showhand align-middle ml-1" visibility="visible"/>
                  </template>
                  <span v-if="data.item.is_read == 1" class="text-white bg-green px-1 ml-1" :title="`Read by ${data.item.read_by}`">R</span>
                  <template v-if="data.item.downloaded == 1">
                    <span class="text-white bg-blue px-1 ml-1" :title="`Downloaded by ${data.item.downloaded_by}`">D</span>
                  </template>
                  <span v-if="data.item.is_hidden == 3" class="text-white bg-yellow px-1 ml-1" title="Can only be unhidden by newsnet staff">N</span>
                  <span v-if="data.item.accepted">{{t('accepted', 'accepted')}}</span>
                </template>
                <template v-slot:cell(status)="data">
                  <b-form-select ref="statusSelector" v-model="formData[data.item.id]" @change="modalCaller" size="sm">
                    <option :value="''" selected></option>
                    <option :value="`queried-${data.index}`">{{t('labelQueried', 'labelQueried')}}</option>
                    <option value="paid">{{t('labelPaid', 'labelPaid')}}</option>
                  </b-form-select>
                </template>
                <template v-slot:cell(value)="data">
                  <template v-if="data.item.total_value">
                    <template v-if="displaySettings.formatValues">
                      {{ data.item.total_value | numberFormat(2) }}
                    </template>
                    <template v-else>
                      {{ data.item.total_value }}
                    </template>
                  </template>
                </template>
                <template v-slot:foot(customer_ref)="data">
                  <span></span>
                </template>
                <template v-slot:foot(document)="data">
                  <span></span>
                </template>
                <template v-slot:foot(status)="data">
                  <span></span>
                </template>
                <template v-slot:foot(value)="data">
                  <template v-if="totalValue">
                    {{t('total', 'total')}} <strong class="text-bold">{{totalValue | numberFormat(2) }}</strong>
                  </template>
                  <template v-else>
                    <span></span>
                  </template>
                </template>
              </b-table>
            </template>
          <h5>{{ t('notifyRemittanceModalPaymentDetails', 'notifyRemittanceModalPaymentDetails') }}</h5>
          <b-form-group>
            <div class="row col-12 align-items-center py-1">
              <label for="paid-via" class="d-block col-8">{{t('willBePaidViaPlsChooseMethod','willBePaidViaPlsChooseMethod') }} *</label>
              <!--<b-form-select id="paid-via" v-model="formData.paymentMethod.paidVia" class="col-4" :options="paymentMethods" ></b-form-select>-->
              <b-form-select id="paid-via" v-model="formData.paymentMethod.paidVia" class="col-4" >
                <b-form-select-option :value="''">{{t('chooseMethod','chooseMethod')}}</b-form-select-option>
                <b-form-select-option value="Bacs">{{t('labelBACS','labelBACS')}}</b-form-select-option>
                <b-form-select-option value="Cheque">{{t('labelCheque','labelCheque')}}</b-form-select-option>
                <b-form-select-option value="Credit_card">{{t('labelCreditCard','labelCreditCard')}}</b-form-select-option>
                <b-form-select-option v-if="clientName == 'look' || clientName == 'looktest'" value="ACH">{{t('labelACH','labelACH')}}</b-form-select-option>
                <b-form-select-option value="Other">{{t('labelOther','labelOther')}}</b-form-select-option>
              </b-form-select>
            </div>
            <div class="row col-12 align-items-center py-1">
              <label for="paid-on" class="d-block col-8">{{t('willBePaidOnPlsChooseDate','willBePaidOnPlsChooseDate') }}</label>
              <datePicker id="paid-on" v-model="formData.paymentMethod.paidOn" class="form-control text-center col-4" :config="datePickerConfig" :placeholder="t('willBePaidOnPlsChooseDate','willBePaidOnPlsChooseDate')"></datePicker>
            </div>
            <template v-if="paidVia == 'Other'">
              <div class="row col-12 align-items-center py-1">
                <label for="paid-other" class="d-block col-8">{{t('pleaseSpecify','pleaseSpecify') }} *</label>
                <input type="text" id="paid-other" v-model="formData.paymentMethod.other" class="form-control text-center col-4" :placeholder="t('pleaseSpecify','pleaseSpecify')">
              </div>
            </template>
            <template v-if="clientName == 'INTE'">
              <div class="row col-12 align-items-top py-1">
                <label for="paid-info" class="d-block col-8">{{t('additionalInstruction','additionalInstruction') }}</label>
                <b-form-textarea id="paid-info" v-model="formData.paymentMethod.info" class="col-4" rows="5" max-rows="5">
                </b-form-textarea>
              </div>
            </template>
          </b-form-group>
          <p class="text-center">{{t('notifyRemittanceModalMandatory', 'notifyRemittanceModalMandatory')}}</p>
        </template>
        <ResponseInfo v-if="getResponseInfo.responseName == 'notifyModal'"></ResponseInfo>
      </template>
      <template v-else>
        <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
        <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
      </template>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="notifyModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="NotifyRemittance" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="!formData.paymentMethod.paidVia || ((formData.paymentMethod.paidVia == 'Other') && (!formData.paymentMethod.other))" @click="notifyRemittance()">
          {{ t('notifyRemittanceButtonText', 'notifyRemittanceButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import datePicker from 'vue-bootstrap-datetimepicker'
import ModalInfoDoc from '@/components/Documents_Search/ModalInfoDoc.vue'
import { clientShortName } from '@/helpers/clientShortName.js'

export default {
  name: 'ModalNotifyRemittance',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'modalCreator',
    'changeModalLevel',
    //'datePickerFormat',
    'searchDocuments',
    //'userLevel',
    //'clientName'
  ],
  data () {
    return {
      notifyModal: {},
      payVia: '',
      docIds: [],
      formData: {
        paymentMethod: {
          paidVia: '',
          paidOn: ''
        },
        docInfos: {}
      },
      fields: [
        {
          key: 'customer_ref',
          label: 'labelAccountNumber',
          sortable: false
        },
        {
          key: 'document',
          label: 'labelInvoiceNumber',
          sortable: false
        },
        {
          key: 'status',
          label: 'labelPaymentStatus',
          sortable: false
        },
        {
          key: 'value',
          label: 'labelValue',
          sortable: false
        }
      ],
      /*
      paymentMethods: [
        { value: '', text: '' },
        { value: 'Bacs', text: this.t('labelBACS', 'labelBACS') },
        { value: 'Cheque', text: this.t('labelCheque', 'labelCheque') },
        { value: 'Credit_card', text: this.t('labelCreditCard', 'labelCreditCard') },
        { value: 'Other', text: this.t('labelOther', 'labelOther') }
      ],*/
      subModal: {
        modalData: {},
        docuData: {},
        updateData: {}
      },
      datePickerConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date(), this.datePickerFormat),
        showClear: true
      },
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    thisButton() {
      return this.$refs['button-close-remittance']
    },
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    /*
    document() {
      return this.$store.getters['documentsStore/getSingleDocument']
    },*/
    displaySettings: {
      get() {
        return this.$store.getters['documentsStore/getDisplaySettings']
      },
      set(newDisplaySettings) {
        this.$store.commit('documentsStore/setDisplaySettings', newDisplaySettings)
      }
    },
    paidVia() {
      return this.formData.paymentMethod.paidVia
    },
    userLevel: {
      get(){
        return this.$store.getters['getUserLevel']
      }
    },
    clientName() {
      let clientName = clientShortName()
      return clientName
    },
    datePickerFormat: {
      get() {
        if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
        }
      }
    }
  },
  watch:{
    paidVia(method) {
      this.buttonIsBusy = false
    }
  },
  methods:{
    clearModal() {
      this.newPostHouse = ''
      this.docIds = []
      this.formData = {
        paymentMethod: {
          paidVia: '',
          paidOn: ''
        },
        docInfos: {}
      }

      this.changeModalLevel('info', 'main')
      this.changeModalLevel('query', 'main')
    },
    calculateTotal() {
      let docs = this.notifyModal.docuData.documentDetails
      let total = 0.00

      for(let i = 0; i < docs.length; i++) {
        let currentDocTotal = docs[i].total_value
        total += parseFloat(currentDocTotal)
      }
      this.totalValue = total
    },
    modalCaller(choice) {
      let queryArray = choice.split('-')
      let type = queryArray[0]
      let docIndex = queryArray[1]
      if(type == 'queried') {
        if(this.notifyModal.modalData.entries == 'single') {
          this.modalCreator({id: 'subQueryModal', title: this.t('documentsSearchRaiseQueryModalHead','documentsSearchRaiseQueryModalHead'), level: 'sub', open: 'open', entries:'single'},
          { docsChecked: [this.notifyModal.docuData.docsChecked], statuses: {docId: this.notifyModal.docuData.docsChecked[0], status: this.notifyModal.docuData.statuses.batch_status, customer: this.notifyModal.docuData.statuses.customer_ref}, docInfo: { reference: this.notifyModal.docuData.documentDetails[0].reference}}, this.$refs.statusSelector.$el)

        } else {
          this.modalCreator({id: 'subQueryModal', title: this.t('documentsSearchRaiseQueryModalHead','documentsSearchRaiseQueryModalHead'), level: 'sub', open: 'open', entries:'single'},
          { docsChecked: [this.notifyModal.docuData.docsChecked[docIndex]], statuses:  this.notifyModal.docuData.statuses[docIndex]}, this.$refs.statusSelector.$el)
        }

      }
    },
    fetchAdditionalInfo(entries) {
      //clear previous response
      this.$store.dispatch('alertClearResponse')

      this.changeModalLevel('info', 'sub')
      this.changeModalLevel('query', 'sub')

      if(entries == 'single') {
        this.$store.dispatch('documentsStore/getSingleDocument',{
          doc_id: this.notifyModal.docuData.statuses.docId
        }).then(() => {
            let thisDocument = this.$store.getters['documentsStore/getDocument']
            this.notifyModal.docuData.documentDetails.push(thisDocument)
          }
        )
        let docuId = this.notifyModal.docuData.statuses.docId
        this.notifyModal.docuData.docsChecked = [docuId]

        this.formData.docInfos = []
        this.formData.docInfos.push({id: docuId, reference: this.notifyModal.docuData.statuses.reference, total_value: this.notifyModal.docuData.statuses.total_value})

        this.formData[docuId] = {}
        this.docIds.push(docuId)
      } else {
        let checkedDocs = this.notifyModal.docuData.docsChecked
        let docIndexes = []
        this.formData.docInfos = []
        Object.keys(this.documents.data).forEach(
          (key) => (checkedDocs.includes(this.documents.data[key].id)) ? (
            (docIndexes.push(this.documents.data[key]))
            &&
            (this.formData.docInfos.push({id: this.documents.data[key].id, reference: this.documents.data[key].reference, total_value: this.documents.data[key].total_value }))
          ) : ''
        )
        this.notifyModal.docuData.documentDetails = docIndexes

        checkedDocs.forEach( (key) => (this.formData[key] = {}))
        checkedDocs.forEach( (key) => (this.docIds.push(key)))
      }

      this.calculateTotal()
    },
    notifyRemittance() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'notifyRemittance',
        documents: this.docIds,
        totalValue: this.totalValue,
        notifyDetails: this.formData,
        docInfo: this.formData.docInfos
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['notify-modal'].hide()
          this.searchDocuments()
        }
      })
    }
  },
  created() {
    this.notifyModal = this.$attrs.modal
    this.notifyModal.docuData.documentDetails = {}
    this.datePickerConfig.format = this.datePickerFormat
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    numberFormat: function(number, digits) {
      return Number.parseFloat(number).toFixed(digits)
    }
  },
  components:{
    ModalInfoDoc,
    ResponseInfo,
    datePicker
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #notifyModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
.modal-open #notifyModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #notifyModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 600px;
  overflow-y: scroll;
}
.text-bold{
  font-weight: bold;
}
.showhand {
  cursor: pointer;
}
</style>
